__turbopack_context__.v({
  "active": "Hero-module__t-zOJG__active",
  "content": "Hero-module__t-zOJG__content",
  "corporateHead": "Hero-module__t-zOJG__corporateHead",
  "corporateSubtitle": "Hero-module__t-zOJG__corporateSubtitle",
  "cta": "Hero-module__t-zOJG__cta",
  "ctaContainer": "Hero-module__t-zOJG__ctaContainer",
  "error": "Hero-module__t-zOJG__error",
  "gradient": "Hero-module__t-zOJG__gradient",
  "gradientOverlay": "Hero-module__t-zOJG__gradientOverlay",
  "loader": "Hero-module__t-zOJG__loader",
  "loaderBlink": "Hero-module__t-zOJG__loaderBlink",
  "logo": "Hero-module__t-zOJG__logo",
  "magicModal": "Hero-module__t-zOJG__magicModal",
  "orgCollabTag": "Hero-module__t-zOJG__orgCollabTag",
  "partner": "Hero-module__t-zOJG__partner",
  "root": "Hero-module__t-zOJG__root",
  "secondary": "Hero-module__t-zOJG__secondary",
  "successContent": "Hero-module__t-zOJG__successContent",
});
